export default "__VITE_ASSET__DAz2oXWe__"